"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var isNull_1 = __importDefault(require("lodash/isNull"));
var mobx_1 = require("mobx");
var convert_case_keys_1 = require("@hikakaku/shared/util/convert_case_keys");
var date_fns_1 = require("date-fns");
var dialog_store_1 = __importDefault(require("~/stores/dialog_store"));
var date_util_1 = require("@hikakaku/shared/util/date_util");
var toString = function (val) { return ((0, isNull_1.default)(val) ? "" : String(val)); };
var userProfileText = function (_a) {
    var name = _a.name, nameKana = _a.nameKana, postalCode = _a.postalCode, address = _a.address, addressDetails = _a.addressDetails, telephoneNumber = _a.telephoneNumber, dateOfBirth = _a.dateOfBirth, profession = _a.profession;
    var birthday = (0, date_util_1.toDate)(dateOfBirth);
    return ("\u30FB\u59D3\u540D(\u6F22\u5B57)\uFF1A ".concat(toString(name), "\n\u30FB\u59D3\u540D(\u30AB\u30BF\u30AB\u30CA)\uFF1A ").concat(toString(nameKana), "\n\u30FB\u90F5\u4FBF\u756A\u53F7\uFF1A ").concat(toString(postalCode), "\n\u30FB\u3054\u4F4F\u6240\uFF1A ").concat(toString(address), " ").concat(toString(addressDetails), "\n\u30FB\u96FB\u8A71\u756A\u53F7\uFF1A ").concat(toString(telephoneNumber), "\n\u30FB\u3054\u5E74\u9F62\uFF1A ").concat(toString(birthday && (0, date_fns_1.differenceInYears)(new Date(), birthday)), "\u6B73\n\u30FB\u751F\u5E74\u6708\u65E5\uFF1A ").concat(toString(birthday && (0, date_fns_1.format)(birthday, 'yyyy/MM/dd')), "\n\u30FB\u3054\u8077\u696D\uFF1A ").concat(toString(profession)));
};
var USERS_PROFILES_PATH = '/users/profiles.json';
var UserProfileStore = /** @class */ (function () {
    function UserProfileStore(_a) {
        var professions = _a.professions, defaultUserProfile = _a.defaultUserProfile;
        var _this = this;
        this.isSaveOnConfirm = true;
        this.errorMessages = [];
        this.handleChangeFormValue = function (key) { return function (value) {
            _this.userProfile[key] = value;
        }; };
        this.handleToggleSaveOnConfirm = function () {
            _this.isSaveOnConfirm = !_this.isSaveOnConfirm;
        };
        this.saveProfile = function () {
            if (!_this.isSaveOnConfirm) {
                return Promise.resolve();
            }
            return axios_1.default
                .put(USERS_PROFILES_PATH, (0, convert_case_keys_1.toSnakeKeys)({ user: _this.userProfile }))
                .catch(function (_a) {
                var response = _a.response;
                var data = response.data;
                if (data && data.version === 'v1') {
                    _this.errorMessages = data.details;
                    throw Error();
                }
                else {
                    dialog_store_1.default.showErrorDialog('プロフィール情報への反映に失敗しました', 'お手数ですが、後ほどプロフィール編集ページより登録情報のご確認をお願いします');
                }
            });
        };
        this.professions = professions;
        this.userProfile = defaultUserProfile;
    }
    Object.defineProperty(UserProfileStore.prototype, "userProfileText", {
        get: function () {
            return userProfileText(this.userProfile);
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_a = typeof UserProfile !== "undefined" && UserProfile) === "function" ? _a : Object)
    ], UserProfileStore.prototype, "userProfile", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], UserProfileStore.prototype, "isSaveOnConfirm", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], UserProfileStore.prototype, "errorMessages", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], UserProfileStore.prototype, "handleChangeFormValue", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], UserProfileStore.prototype, "handleToggleSaveOnConfirm", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], UserProfileStore.prototype, "saveProfile", void 0);
    return UserProfileStore;
}());
exports.default = UserProfileStore;
